<template>
  <div
    id="topHeader"
    ref="headerRef"
    class="us-header new-us-header"
    :class="[`header-${$store.state.locale}`]"
  >
    <!-- 第一导航栏 - 共用部分 -->
    <nav v-if="firstNavList.length > 0" class="us-first-nav">
      <div :class="['first-nav-wrap', { 'mobile-first-nav': isMobile }]">
        <a
          v-for="item in firstNavList"
          :key="item.name"
          class="nav-item"
          :class="{ active: '/' === item.url }"
          :title="item.name"
          :target="item.target === '_blank' ? '_blank' : '_self'"
          :href="item.url"
          @click="handleClickNav(item.name, item.url)"
        >
          <img
            v-lazy-load :data-src="require('assets/images/common/think-icon.png')"
            :data-not-lazy="true"
            alt="think-online-hedader-icon"
            :class="['first-nav-icon', {'mobile-first-nav-icon': isMobile}]"
          >
          <span
            class="nav-item-link"
          >
            {{ item.name }}
          </span>
        </a>
      </div>
    </nav>

    <!-- 第二导航栏 - 响应式部分 -->
    <nav class="us-second-nav">
      <div
        :class="[
          'second-nav-wrap',
          {
            'mobile-second-nav': isMobile,
            'bg-change': showSide
          }
        ]"
      >
        <div class="logo">
          <a :href="siteJumpUrl" :title="$t('common.websiteName')" @click="handleClickNav($t('common.websiteName'), '/')">
            <img
              class="log-img"
              :data-not-lazy="true"
              v-lazy-load :data-src="logoSrc"
              :alt="$t('common.websiteName')"
              :height="logoSize.height"
              :width="logoSize.width"
            >
          </a>
        </div>

        <div v-if="!isMobile" :class="['second-nav-mid', `second-nav-mid-${$store.state.locale}`]">
          <div
            v-for="item in secondNavList"
            :key="item.onlyID"
            class="second-nav-item"
            :class="{ active: isItemOrChildActive(item) }"
            :title="item.name"
            @click="handleClickNav(item.name)"
          >
            <a
              v-if="item.url"
              class="second-nav-item-link text-overflow-ellipsis"
              :target="item.target === '_blank' ? '_blank' : '_self'"
              :href="item.url"
              :class="{ active: isItemOrChildActive(item) }"
            >
              {{ item.name }}
            </a>
            <div v-else class="second-nav-item-link text-overflow-ellipsis" :class="{ active: isItemOrChildActive(item) }">
              {{ item.name }}
            </div>
            <span v-if="item.children && item.children.length" class="iconfont icon-arrow-bottom-outline"></span>
            <div
              v-if="item.children && item.children.length"
              :class="['dropdown-list-wrapper', `dropdown-list-wrapper-${$store.state.locale}`]"
            >
              <ul class="dropdown-list">
                <li v-for="childItem in item.children" :key="childItem.name" class="dropdown-item">
                  <a
                    v-if="childItem.url"
                    class="dropdown-item-link"
                    :class="{ active: isChildActive(childItem) }"
                    :href="childItem.url"
                    :target="childItem.target === '_blank' ? '_blank' : '_self'"
                    @click.stop="handleClickNav(childItem.name)"
                  >
                    {{ childItem.name }}
                  </a>
                  <div
                    v-else
                    class="dropdown-item-link hover-color-transition"
                    :class="{ active: isChildActive(childItem) }"
                  >
                    {{ childItem.name }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- 移动端导航 -->
        <div v-if="isMobile" class="us-second-nav-right">
          <template v-if="!isLogin && conversionComponents.length > 0">
            <!-- 预约诊断 -->
            <a
              v-if="conversionComponents[0].conversionType === 'link'"
              :class="['evaluation-btn', 'menu-btn-item']"
              :href="conversionComponents[0].url"
              :target="conversionComponents[0].target"
            >{{ conversionComponents[0].name }}</a>
            <!-- 分诊台 -->
            <div
              v-if="conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 69"
              :class="['evaluation-btn', 'menu-btn-item']"
              @click="handleToFZ(`/triage-desk/${conversionComponents[0].leadComponentId}`)"
            >
              {{ conversionComponents[0].name }}
            </div>
            <!-- 留资组件 -->
            <div
              v-if="conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 35"
              :class="['evaluation-btn', 'menu-btn-item']"
              @click="handleLZ(conversionComponents[0].leadComponentId)"
            >
              {{ conversionComponents[0].name }}
            </div>
          </template>
          <div v-if="showSide" class="switch-btn icon-menu-close-btn" @click="showHeaderSettings" />
          <div v-else class="switch-btn icon-menu-open-btn" @click="showHeaderSettings" />
        </div>

        <!-- 右侧导航 电脑端 -->
        <div v-if="!isMobile" class="second-nav-right">
          <div v-if="isLogin" class="my-courses-content">
            <div class="my-courses-wrap">
              <a class="my-courses-text" href="/study#/home/today">My Courses</a>
            </div>
            <!-- 线上火星开启 便于测试 -->
            <div v-if="isHaveHomework" class="homework-icon" @click="goHomework">
              <div class="animation-wrapper">
                <i class="iconfont icon-attend-the-class" />
                <div v-if="isShowHomeworkTip" class="icon-tip" />
              </div>
              <!-- <div class="icon-wrapper">
                <img class="icon" v-lazy-load data-src="~assets/images/icon/icon-homework.svg">
              </div> -->
            </div>
          </div>
          <div v-if="!isLogin" class="login-content">
            <div class="login-wrap" @click="handleLogin">
              <span class="sign-in-text">{{ langContext.signIn }}</span>
            </div>
          </div>
          <div v-if="isLogin" class="logged-content">
            <div class="logged-in-wrap">
              <div class="user-avatar">
                <img
                  :data-not-lazy="true"
                  v-lazy-load :data-src="`${userInfo.parentAvatar}?im=Resize=(112,112)`"
                  :alt="userInfo.parentNickname"
                  width="26"
                  height="26"
                >
              </div>
              <div class="info-text text-overflow-ellipsis">
                {{ userInfo.parentNickname || $t("common.parent") }}
              </div>
              <span class="iconfont icon-arrow-bottom-outline" />
              <div :class="['dropdown-list-wrapper', `dropdown-list-wrapper-${$store.state.locale}`]">
                <ul class="dropdown-list">
                  <li
                    v-for="(item, index) in userNavigationLinks"
                    :key="item.name + index"
                    class="dropdown-item"
                  >
                    <a
                      v-if="item.target && item.target === '_blank'"
                      class="dropdown-item-link"
                      :href="item.url"
                      target="_blank"
                    >{{ item.name }}</a>
                    <nuxt-link
                      v-else-if="item.url != ''"
                      class="dropdown-item-link"
                      :to="item.url"
                    >
                      {{ item.name }}
                    </nuxt-link>
                  </li>
                  <li class="dropdown-item">
                    <div
                      class="dropdown-item-link"
                      @click="handleLogout()"
                    >
                      {{ langContext.signOut }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            v-if="!isLogin && !isMobile && conversionComponents.length > 0"
            :class="[
              'normal-conversion-component',
              {
                'conversion-component': conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 35
              },
              `conversion-component-${$store.state.locale}`,
            ]"
          >
            <!-- 预约诊断 -->
            <a
              v-if="conversionComponents[0].conversionType === 'link'"
              class="evaluation-btn"
              :href="conversionComponents[0].url"
              :target="conversionComponents[0].target"
            >{{ conversionComponents[0].name }}</a>
            <!-- 分诊台 -->
            <div
              v-if="conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 69"
              class="evaluation-btn"
              @click="handleToFZ(`/triage-desk/${conversionComponents[0].leadComponentId}`)"
            >
              {{ conversionComponents[0].name }}
            </div>
            <!-- 留资组件 -->
            <div
              v-if="conversionComponents[0].conversionType === 'lead' && conversionComponents[0].conversionComponentType === 35"
              class="evaluation-btn lead-evaluation-btn"
              @click="handleLZ(conversionComponents[0].leadComponentId)"
            >
              {{ conversionComponents[0].name }}
            </div>
          </div>
        </div>

        <!-- 留资组件 -->
        <transition name="slide-down">
          <div
            v-if="showSlideLead"
            ref="leadPostion"
            :class="[
              'lz-position-top',
              `lz-position-top-${$store.state.locale}`,
              {'position-down': showLeadComponent, 'hide-after-animation': !showLeadComponent}
            ]"
          >
            <div v-if="Object.keys(moduleInfo).length === 0" class="placeholder-content">
              <div class="loading-content">
                <div class="loader" />
              </div>
              <div class="bottom-placeholder" />
            </div>
            <transition name="fade">
              <LeadData
                v-if="Object.keys(moduleInfo).length > 0"
                ref="leadDataRef"
                :locale="locale"
                :module-id="moduleInfo.moduleId"
                :component-name="moduleInfo.componentName"
                :component-type="moduleInfo.componentType"
                :component-title="moduleInfo.componentTitle"
                v-bind="moduleInfo.componentData"
                @saveSuccess="handleCloseLead"
              />
            </transition>
            <div class="lz-position-close-btn" @click="handleCloseLead">
              {{ leadBtnText }}
            </div>
          </div>
        </transition>
      </div>
    </nav>

    <!-- 移动端侧边菜单 -->
    <transition name="dropdown">
      <div
        v-if="showSide && isMobile"
        ref="settingPopRef"
        :class="['settings-pop', `settings-pop-${$store.state.locale}`]"
      >
        <div v-if="isLogin" class="menu-actions">
          <div class="my-courses-wrap menu-btn-item">
            <a class="my-courses-text" href="/my-courses/list">My Courses</a>
          </div>
          <div :class="['logged-in-wrap menu-btn-item', {'active': showLoggedInDropdown}]" @click="toggleLoggedInDropdown">
            <img
              :data-not-lazy="true"
              v-lazy-load :data-src="`${userInfo.parentAvatar}?im=Resize=(112,112)`"
              :alt="userInfo.parentNickname"
              width="26"
              height="26"
            >
            <div class="info-text text-overflow-ellipsis">
              {{ userInfo.parentNickname || $t("common.parent") }}
            </div>
            <span class="iconfont icon-arrow-bottom-outline" />
          </div>
        </div>
        <!-- 点击登录后的name下拉 -->
        <transition name="dropdown">
          <div v-if="showLoggedInDropdown && isLogin" class="dropdown-list-wrapper footer-dropdown">
            <ul class="dropdown-list">
              <li
                v-for="(item, index) in userNavigationLinks"
                :key="item.name + index"
                class="dropdown-item"
              >
                <a
                  v-if="item.target && item.target === '_blank'"
                  class="dropdown-item-link"
                  :href="item.url"
                  target="_blank"
                >{{ item.name }}</a>
                <nuxt-link
                  v-else-if="item.url != ''"
                  class="dropdown-item-link"
                  :to="item.url"
                >
                  {{ item.name }}
                </nuxt-link>
              </li>
            </ul>
          </div>
        </transition>
        <template>
          <div
            v-for="item in excludeMathGame"
            :key="item.name + item.onlyID"
            class="second-nav-item"
            :class="{ 'active': activeDropdown === item.onlyID }"
            :title="item.name"
          >
            <div class="second-nav-item-header" @click="toggleDropdown(item.onlyID, $event)">
              <a
                v-if="item.url"
                class="second-nav-item-link hover-color-transition"
                :target="item.target === '_blank' ? '_blank' : '_self'"
                :href="item.url"
              >
                {{ item.name }}
              </a>
              <div v-else class="second-nav-item-link hover-color-transition">
                {{ item.name }}
              </div>
              <span v-if="item.children && item.children.length" class="iconfont icon-arrow-bottom-outline" />
            </div>
            <div
              v-if="item.children && item.children.length"
              class="dropdown-list-wrapper"
              :class="{ 'active': activeDropdown === item.onlyID }"
            >
              <ul class="dropdown-list">
                <li v-for="childItem in item.children" :key="childItem.name" class="dropdown-item">
                  <a
                    v-if="childItem.url"
                    class="dropdown-item-link hover-color-transition"
                    :href="childItem.url"
                    :target="
                      childItem.target === '_blank' ? '_blank' : '_self'
                    "
                    @click.stop="handleClickNav(childItem.name)"
                  >
                    {{ childItem.name }}
                  </a>
                  <div
                    v-else
                    class="dropdown-item-link hover-color-transition"
                  >
                    {{ childItem.name }}
                  </div>
                </li>
              </ul>
            </div>
            <!-- <div class="placehoder-box">
              <div class="bottom-line" />
            </div> -->
          </div>
          <div v-if="!isLogin" class="second-nav-item" @click="handleLogin('')">
            <div class="second-nav-item-link  second-nav-item-link-sign">
              {{ langContext.signIn }}
            </div>
          </div>
          <div v-else class="second-nav-item" @click="handleLogout()">
            <div class="second-nav-item-link second-nav-item-link-sign">{{ langContext.signOut }}</div>
          </div>
        </template>
      </div>
    </transition>

    <!-- 移动端展示留资 -->
    <transition name="dropdown">
      <div v-if="isMobile && showLeadComponent" ref="leadInfoRef" class="lead-info-box mobile-lead-info-box">
        <div v-if="loadingModules" class="loading-content">
          <div class="loader" />
        </div>
        <div v-if="Object.keys(moduleInfo).length > 0" class="lead-title">
          {{ moduleInfo.componentData.title }}
          <span v-if="showSide" class="iconfont iconcha" @click="closeLead" />
        </div>
        <LeadData
          v-if="Object.keys(moduleInfo).length > 0"
          ref="leadDataRef"
          :locale="locale"
          :module-id="moduleInfo.moduleId"
          :component-name="moduleInfo.componentName"
          :component-type="moduleInfo.componentType"
          :component-title="moduleInfo.componentTitle"
          v-bind="moduleInfo.componentData"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { removeCookies } from 'common/utils';
import { oneApi } from 'config/api';
import bus from 'common/bus';
import mixin from './mixin';

const LeadData = () => import(/* webpackPrefetch: true */ '../LeadData/web');

export default {
  components: {
    LeadData,
  },

  mixins: [mixin],
  data() {
    return {
      isMobile: false,
      showSide: false,
      activeDropdown: null,
      showAdressDropdown: false,
      showLoggedInDropdown: false,
      loadingModules: false,
      moduleInfo: {},
      showLeadComponent: false,
      scrollbarWidth: '',
    };
  },
  computed: {
    // 计算logo的height和width
    logoSize() {
      if (this.isMobile && this.schoolCode === '105') {
        return {
          height: 26,
          width: 132,
        };
      }
      // 条件1：如果是移动端（isMobile为true），优先用移动端尺寸
      if (this.isMobile) {
        return {
          height: 28,
          width: 194,
        };
      }

      // 条件4：其他情况（非移动端、未滚动、非105学校）
      return {
        height: 30,
        width: 206,
      };
    },
    leadBtnText() {
      if (this.showLeadComponent) {
        return 'Close';
      }
      return this.conversionComponents.length ? this.conversionComponents[0].name : '';
    },
    showSlideLead() {
      return !this.isLogin && !this.isMobile && this.conversionComponents.length > 0 && this.conversionComponents[0].conversionType === 'lead' && this.conversionComponents[0].conversionComponentType === 35
    },
  },
  watch: {
    showLeadComponent(newVal) {
      // 当showLeadComponent为true时，禁止body滚动
      if (!this.scrollbarWidth) {
        this.scrollbarWidth = this.getScrollbarWidth(); // 获取滚动条宽度
      }
      if (newVal) {
        document.body.style.overflow = 'hidden';
        console.log('ddd', this.scrollbarWidth);
        // 可选：添加padding-right抵消滚动条消失导致的页面抖动
        document.body.style.paddingRight = `${this.scrollbarWidth}px`; // 数值根据实际滚动条宽度调整
      } else {
        // 恢复默认滚动
        document.body.style.overflow = ''; // 清空样式，恢复默认
        document.body.style.paddingRight = '';
      }
    },
    isLogin(newVal) {
      if (newVal === true) {
        if (this.locale === 'hk' || this.locale === 'cn') {
          this.isCheckHaveHomework()
        }
      } else {
        this.isHaveHomework = false;
      }
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);

    if (this.isLogin) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showmap, this.error);
      }
      console.log('获取地理位置成功');

      if (this.locale === 'hk' || this.locale === 'cn') {
        console.log('isCheckHaveHomework');
        this.isCheckHaveHomework()
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
    // bus.$off('login');
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleLogin(obj = {}) {
      const parm = {
        triggerSource: 'header',
        ...obj,
      }
      console.log('parm', parm);
      bus.$emit('login', parm);
    },
    async handleLogout() {
      await this.$axios.post(
        oneApi.commonLogout,
        {},
        { rewritePostBody: true },
      );
      removeCookies('_official_token');
      this.$store.dispatch('ucenter/resetUserInfo');
      this.$store.commit('ucenter/SET_UNPAID_LIST', {});
      this.$store.commit('ucenter/SET_IS_LOGIN', false);
      this.$router.push(this.siteJumpUrl);
    },
    showHeaderSettings() {
      this.showSide = !this.showSide;
      if (this.showSide) {
        this.showOrHideContainer('none');
      } else {
        this.showOrHideContainer('block');
      }
    },
    showOrHideContainer(displayStyle) {
      this.$nextTick(() => {
        const { settingPopRef } = this.$refs;
        const { headerRef } = this.$refs;
        if (settingPopRef) {
          settingPopRef.style.display = this.showSide ? 'block' : 'none';
        }
        if (headerRef) {
          headerRef.style.minHeight = this.showSide ? '100vh' : '0';
        }
        console.log(`settingPopRef 显示状态: ${this.showSide ? '显示' : '隐藏'}  displayStyle: ${displayStyle}`);
      });
      if (displayStyle) {
        this.$emit('getChildRefs', (refs) => {
          try {
            // 安全访问父组件元素
            if (refs.element1) {
              const targetElement = refs.element1.$el || refs.element1;
              targetElement.style.display = displayStyle;
              console.log(`父组件element1元素已设置为 : ${displayStyle}`);
            }
            if (refs.element2) {
              const targetElement = refs.element2.$el || refs.element2;
              targetElement.style.display = displayStyle;
              console.log(`父组件element2元素已设置为: ${displayStyle}`);
            }
            if (refs.element3) {
              const targetElement = refs.element3.$el || refs.element3;
              targetElement.style.display = displayStyle;
              console.log(`父组件element3元素已设置为: ${displayStyle}`);
            }
          } catch (error) {
            console.error('设置父组件样式时出错:', error);
          }
        });
      }
    },
    toggleDropdown(id, event) {
      if (event.target.tagName === 'A') return;
      if (this.activeDropdown === id) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = id;
      }
    },
    toggleAdressDropdown() {
      this.showAdressDropdown = !this.showAdressDropdown;
      this.showLoggedInDropdown = false;
      if (this.showAdressDropdown) {
        this.$refs.headerRef.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    },
    toggleLoggedInDropdown() {
      this.showLoggedInDropdown = !this.showLoggedInDropdown;
      this.showAdressDropdown = false;
      if (this.showLoggedInDropdown) {
        this.$refs.headerRef.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    },
    handleToFZ(successUrl) {
      if (!this.isLogin) {
        this.handleLogin({ successUrl, triggerSource: 'down' });
      }
    },
    async handleLZ(id) {
      console.log('组件id', id);
      this.showLeadComponent = true;
      if (this.isMobile) {
        this.$nextTick(() => {
          const { settingPopRef } = this.$refs;
          const { leadInfoRef } = this.$refs;
          // const { headerRef } = this.$refs;
          if (settingPopRef) {
            settingPopRef.style.display = 'none';
          }
          if (leadInfoRef) {
            leadInfoRef.style.display = 'block'
            leadInfoRef.style.minHeight = '100vh';
          }
        });
      }
      if (Object.keys(this.moduleInfo).length === 0) {
        await this.queryModuleInfo(id);
      } else {
        this.$refs.leadDataRef && this.$refs.leadDataRef.retsetFormDataList();
      }
    },
    /**
     * 获取留资组件内容
     */
    async queryModuleInfo(id) {
      this.loadingModules = true
      const params = { moduleIdList: [Number(id)] }
      const res = await this.$axios.post(oneApi.queryPageModule, params, { rewritePostBody: true })
      this.loadingModules = false
      if (res.code !== 0) {
        return
      }
      try {
        const moduleList = []
        res.data.moduleList.forEach((item) => {
          if (item.content) {
            const modueleContent = JSON.parse(item.content)
            modueleContent.moduleId = String(item.id)
            const modueleCompData = modueleContent.componentData || {}
            if (item.type === 46 && Array.isArray(modueleCompData.dataList) && !modueleCompData.dataList.length) return
            moduleList.push(modueleContent)
          }
        })
        // eslint-disable-next-line prefer-destructuring
        this.moduleInfo = moduleList[0]
        console.log('moduleList', this.moduleInfo)
      } catch (error) {
        console.log(error)
      }
    },
    handleCloseLead() {
      if (this.showLeadComponent) {
        this.showLeadComponent = false;
        const element = this.$refs.leadDataRef;
        console.log('leadDataRef', element)
        if (element && element.$el) {
          element?.resetFormFields();
          const { height } = element.$el.getBoundingClientRect();
          const leadPostionDom = this.$refs.leadPostion;
          console.log('leadPostionDom', leadPostionDom);
          if (leadPostionDom) {
            // leadPostionDom.style.opacity = '0';
            leadPostionDom.style.top = `-${height}px`;
          }
        }
      } else {
        this.handleLZ(this.conversionComponents[0].leadComponentId);
      }
    },
    // 移动端close
    closeLead() {
      this.showLeadComponent = false;
      this.$nextTick(() => {
        const { settingPopRef } = this.$refs;
        const { leadInfoRef } = this.$refs;
        // const { headerRef } = this.$refs;
        if (settingPopRef) {
          settingPopRef.style.display = 'block';
        }
        if (leadInfoRef) {
          leadInfoRef.style.display = 'none'
          leadInfoRef.style.minHeight = '0';
        }
      });
    },
    async goHomework() {
      // 在用户交互中立即打开新窗口（避免 Safari 阻止）
      const newWindow = window.open('', '_blank');
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        this.$Dialog.alert('弹窗被阻止，请检查浏览器设置！')
        return;
      }

      try {
        await this.getTempToken();
        const url = `${process.env.homeworkUrl}?token=${this.TempToken}&env=${process.env.runtime}&schoolCode=${this.schoolCode}&sourceUrl=${window.location.href}`;
        newWindow.location.href = url
      } catch (error) {
        console.error('Error fetching TempToken:', error);
        newWindow.close();
      }
    },
    getScrollbarWidth() {
      // 创建两个容器，通过宽度差计算滚动条宽度
      const outer = document.createElement('div');
      outer.style.cssText = `
        visibility: hidden;
        width: 100px;
        height: 50px;
        overflow: scroll; /* 让外层容器产生滚动条 */
        position: absolute;
        top: -9999px; /* 隐藏在视口外 */
      `;
      document.body.appendChild(outer);

      // 内层容器用于测量可用宽度
      const inner = document.createElement('div');
      inner.style.width = '100%';
      inner.style.height = '200%'; // 确保外层产生滚动条
      outer.appendChild(inner);

      // 外层总宽度 - 内层可用宽度 = 滚动条宽度
      const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

      // 清理DOM
      outer.remove();

      // 兜底处理：如果计算为0，使用常见的15px作为默认值
      return scrollbarWidth || 15;
    },
    normalizePath(path) {
      if (!path) return '';
      try {
        const url = String(path).split('?')[0];
        return url !== '/' && url.endsWith('/') ? url.replace(/\/+$/, '') : url;
      } catch (e) {
        return path;
      }
    },
    isUrlActive(url) {
      const current = this.normalizePath(this.currentRoutePath);
      const target = this.normalizePath(url);
      if (!target) return false;
      return current === target;
    },
    isChildActive(childItem) {
      if (!childItem) return false;
      return this.isUrlActive(childItem.url);
    },
    isItemOrChildActive(item) {
      if (!item) return false;
      if (this.isUrlActive(item.url)) return true;
      if (Array.isArray(item.children)) {
        return item.children.some((c) => this.isChildActive(c));
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.us-header {
  position: sticky;
  width: 100%;
  // margin-top: 74px;
  top: 0;
  z-index: 1000;

  &.is-close {
    margin-top: 50px; // 这的高度要和first-nav-wrap的高度一样
  }

  /* 第一导航栏 */
  .us-first-nav {
    width: 100%;
    background: #FF5A00;
    z-index: 1002;

    .first-nav-wrap {
      width: 1280px;
      margin: 0 auto;
      height: 40px;
      display: flex;
      align-items: center;

      &.mobile-first-nav {
        width: 100%;
        height: 40px;
      }
    }

    .nav-item {
      height: 100%;
      // width: 225px;
      font-family: Poppins;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 15px;
      letter-spacing: 0%;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 8px 20px;

      .first-nav-icon {
        width: 45px;
        height: 18px;
        margin-bottom: 5px;
      }

      &.active {
        background: #DB4D00;
      }
    }

    .nav-item-link {
      font-family: 'Poppins', sans-serif;
      margin-left: 4px;
    }
  }

  /* 第二导航栏 */
  .us-second-nav {
    z-index: 1000;
    background: #fff;
    width: 100%;
    transition: all 0.5s ease;
    // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    .second-nav-wrap {
      width: 1280px;
      margin: 0 auto;
      height: 80px;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: space-between;

      &.mobile-second-nav {
        width: 100%;
        padding: 0;
        height: 14.93333vw;
        justify-content: space-between;
      }
    }

    .logo {
      flex-shrink: 0;
      // margin-top: 13px;
      // margin-bottom: auto;  /* 抵消flex居中的默认效果 */
      a {
        display: block;
      }

      .log-img {
        display: block;
        transition: all 0.5s ease;
      }
    }

    /* 公共下拉菜单 */
    .dropdown-list-wrapper {
      display: none;
      position: absolute;
      left: 50%;
      transform: translateX(-50%) scaleY(0);
      opacity: 0;
      z-index: 99;
      transition: opacity 0.2s ease-out;

      .dropdown-list {
        position: relative;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        z-index: 99;
        list-style: none !important;
        padding: 0;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
        padding: 8px;

        .dropdown-item {
          position: relative;
          font-family: Poppins;
          font-weight: 400;
          font-style: Regular;
          font-size: 14px;
          leading-trim: NONE;
          line-height: 100%;
          letter-spacing: 0%;
          text-align: center;
          white-space: nowrap;
          color: rgba(0, 0, 0, 0.9);

          &:hover {
            .dropdown-item-link {
              background: rgba(240, 240, 240, 1);
              border-radius: 8px;
              border-bottom-width: 0.5px;
            }
          }

          &.is-select {

            .dropdown-item-link {
              // color: #ff9f0a;
            }
          }

          .dropdown-item-link {
            height: 46px;
            font-family: Poppins;
            font-weight: 400;
            font-style: Regular;
            font-size: 14px;
            leading-trim: NONE;
            padding: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(0, 0, 0, 0.9);

            &.active {
              // color: #FF5A00D9;
              text-decoration: underline;
              text-decoration-style: solid;
              text-decoration-offset: 25%;
              text-decoration-thickness: 16%;
              text-decoration-color: #FF5A00D9;
            }
          }

          .compuse-distance {
            margin-left: 100px;
          }
        }

        .dropdown-item-compuse {
          .dropdown-item-link {
            justify-content: space-between;
          }
        }
      }
    }

    /* 中间导航 - 桌面端 */
    .second-nav-mid {
      height: 100%;
      flex: 1;
      display: flex;
      align-items: center;
      margin-left: 167px;

      &.hidden {
        opacity: 0;
      }
    }

    .second-nav-item {
      position: relative;
      height: 100%;
      // margin-left: 11px;
      font-family: Poppins;
      font-weight: 700;
      font-style: Bold;
      font-size: 14px;
      letter-spacing: 0%;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 29px 16px;

      &.active {
        border-bottom: 2px solid #FF5A00;
        .icon-arrow-bottom-outline {
          color: #FF5A00D9;
        }
        &:hover {
          .second-nav-item-link {
            color: #FF5A00D9;
          }
          .icon-arrow-bottom-outline {
            color: #FF5A00D9;
          }
        }
      }

      .second-nav-item-link {
        font-size: 14px;
        font-weight: 700;
        color: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        &.active {
          text-decoration: underline;
          text-decoration-style: solid;
          text-decoration-offset: 25%;
          text-decoration-thickness: 10%;
          text-decoration-skip-ink: auto;
          color: #FF5A00D9;

        }
      }
      .icon-arrow-bottom-outline {
        font-size: 14px;
        margin-left: 4px;
        transition: transform 0.3s ease;
        color: rgba(0, 0, 0, 0.85);
      }

      &:hover {
        .second-nav-item-link {
          // background: #eee;
          color: rgba(0, 0, 0, 0.6);
          text-decoration: underline;
          text-decoration-style: solid;
          text-decoration-offset: 25%;
          text-decoration-thickness: 10%;
          text-decoration-skip-ink: auto;
        }
        .icon-arrow-bottom-outline {
          transform: rotate(180deg);
          color: rgba(0, 0, 0, 0.6);
        }

        .dropdown-list-wrapper {
          display: block;
          top: 80px;
          transform: translateX(-50%);
          opacity: 1;
          transition: opacity 0.2s ease-in;
        }
      }
    }

    /* 右侧导航 */
    .second-nav-right {
      display: flex;
      align-items: center;
      height: 100%;

      .logged-content {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 24px;

        &:hover {
          .logged-in-wrap {

            .info-text {
              text-decoration: underline;
              text-decoration-style: solid;
              text-decoration-offset: 25%;
              text-decoration-thickness: 10%;
              text-decoration-skip-ink: auto;
              color: rgba(0, 0, 0, 0.6);
            }

            .dropdown-list-wrapper {
              display: block;
              top: 52px;
              transform: translateX(-50%);
              opacity: 1;
              transition: opacity 0.2s ease-in;
            }

            .icon-arrow-bottom-outline {
              transform: rotate(180deg);
              color: rgba(0, 0, 0, 0.6);
            }
          }
        }
      }

      .my-courses-content,
      .login-content {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .homework-icon {
        color: var(--txt-color-link);
        cursor: pointer;

        .animation-wrapper {
          margin-right: 8px;
          position: relative;

          .icon-tip {
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            bottom: 24px;
            left: 22px;
            background: #ff674e;
          }
        }
      }

      .login-wrap,
      .my-courses-wrap,
      .logged-in-wrap {
        position: relative;
        display: flex;
        align-items: center;
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 100%;
        letter-spacing: 0%;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.85);
      }

      .icon-arrow-bottom-outline {
        transition: transform 0.5s ease;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }

      .login-wrap {
        &:hover {
          .sign-in-text {
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }
      .my-courses-wrap {
        &:hover {
          .my-courses-text {
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }

      .logged-in-wrap {
        .user-avatar {
          width: 26px;
          height: 26px;
        }
      }

      .info-text {
        margin: 0 4px;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // flex-shrink: 0;
        text-align: center;
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 100%;
        letter-spacing: 0%;
        color: rgba(0, 0, 0, 0.85);

      }

      .normal-conversion-component {
        position: relative;
        margin-left: 12px;

        .evaluation-btn {
          max-width: 152px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          padding: 12px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #FF5A00;
          border: none;
          color: #fff;
          border-radius: 80px;
          cursor: pointer;
          font-family: Poppins;
          font-weight: 700;
          font-style: Bold;
          font-size: 14px;
          line-height: 100%;
          letter-spacing: 0%;
          text-align: center;

          &:hover {
            background: rgba(255, 90, 0, 0.85);
          }
        }
      }

      .conversion-component {
        width: 150px;

        .evaluation-btn {
          width: 150px;
          height: 80px;
          padding: 0 28px;
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
          border-radius: 0 0 15px 15px;
          opacity: 1;
          line-height: 20px;
        }
      }

    }
  }

  /* 移动端侧边菜单 */
  .settings-pop {
    width: 100%;
    position: relative;
    background: #FFFFFF;
    flex-direction: column;
    z-index: 2000;
    display: none;

    .icon-arrow-bottom-outline {
      transition: transform 0.5s ease;
    }
    .menu-actions {
      width: 100%;
      height: 60px;
      background: #FFFFFF;
      display: flex;
      align-items: center;
      padding: 0 20px;
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
      .menu-btn-item + .menu-btn-item  {
        margin-left: 15px;
      }
      .menu-btn-item {
        width: 160px;
        height: 40px;
        border-radius: 200px;
        gap: 15px;
        padding: 8px 20px;
        border: 1px solid #FF5A00;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 16px;
        leading-trim: NONE;
        line-height: 100%;
        letter-spacing: 0%;
        color: #FF5A00;

        a {
          color: #FF5A00;
        }
      }
      .text-overflow-item {
        width: auto;
        flex: 1 0 auto;
      }

      .login-wrap {
        // background: #36B8E0;
        .sign-in-text {
          // margin-left: 10px;
        }
      }

      .my-courses-wrap {
        .my-courses-text {
          // margin-left: 10px;
        }
      }

      .logged-in-wrap {
        .user-avatar {
          width: 22px;
          height: 22px;
        }

        .info-text {
          margin: 0 3px;
          width: 81px;
          max-width: 81px;
        }
        &.active {
          .icon-arrow-bottom-outline {
            transform: rotate(180deg);
          }
        }
      }
    }

    .second-nav-item {
      height: 60px;
      display: flex;
      flex-direction: column;
      transition: height 0.3s ease;
      overflow: hidden;
      position: relative;
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);

      &.active {
        .icon-arrow-bottom-outline {
          transform: rotate(180deg);
        }
      }

      .second-nav-item-link {
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        leading-trim: NONE;
        letter-spacing: 0%;
        text-align: center;
        color: rgba(0, 0, 0, 0.85);
        height: 100%;
        line-height: 60px;
      }

      .second-nav-item-link-sign {
        color: #FF5A00;
      }

      .icon-arrow-bottom-outline {
        color: rgba(0, 0, 0, 0.85);
      }

      .second-nav-item-header {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 0 20px;
        .icon-arrow-bottom-outline {
          display: inline-block;
          margin-left: 4px;
          margin-top: 5px;
          color: rgba(0, 0, 0, 0.85);
        }
      }

      .dropdown-list-wrapper {
        max-height: 0;
        overflow: hidden;
        background: rgba(247, 247, 247, 1);
      }

      .dropdown-list-wrapper.active {
        max-height: 1000px;

      }

      .dropdown-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .dropdown-item {
        height: 61px;
        padding: 0 20px;
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 61px;
        letter-spacing: 0%;
        text-align: center;
        color: #00000099;
      }

      .dropdown-item:active {
        color: #FF5A00;
        .dropdown-item-link {
          color: #FF5A00;
        }
      }

      .dropdown-item-link {
        height: 61px;
        padding: 0 20px;
        font-family: Poppins;
        font-weight: 700;
        font-style: Bold;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 61px;
        letter-spacing: 0%;
        text-align: center;
        color: #00000099;
        text-decoration: none;
      }
    }

    .second-nav-item.active {
      height: auto;
    }

    .footer-dropdown {
      // margin-top: 5px;
      width: 100%;
      background: rgba(247, 247, 247, 1);
      .dropdown-list {
        list-style: none;
        padding: 0;

        .dropdown-item {
          // padding: 0 26px;
          &.is-select {
            // background: #FFF5E3;

          }
          &.active {
            // background: #FFF5E3;
            // color: #FA9E00;
          }
        }

        .dropdown-item-link {
          height: 61px;
          line-height: 61px;
          color: rgba(0, 0, 0, 0.85);
          font-family: Poppins;
          font-weight: 700;
          font-style: Bold;
          font-size: 14px;
          leading-trim: NONE;
          line-height: 20px;
          letter-spacing: 0%;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .dropdown-item:active {
        color: #FF5A00;

      }
    }
  }

  /* 下拉动画 */
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: all 0.3s ease;
    overflow: hidden;
  }

  .dropdown-enter,
  .dropdown-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-10px);
  }

  .dropdown-enter-to,
  .dropdown-leave {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0);
  }

  .slide-down-enter-active,
  .slide-down-leave-active {
    transition: top 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  }

  .slide-down-enter-from,
  .slide-down-leave-to {
    top: -529px;
  }

  .slide-down-enter-to,
  .slide-down-leave-from {
    top: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .lz-position-top {
    position: absolute;
    top: -529px;
    right: -28px;
    z-index: 1001;
    background: #fff;
    transition: top 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);

    .placeholder-content {
      width: 643px;
      height: 529px;
      display: flex;
      flex-direction: column;

      .loading-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .loader {
          width: 50px;
          height: 50px;
          border: 5px solid #f3f3f3;
          border-top: 5px solid #fa6000;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
      }

      .bottom-placeholder {
        margin-top: 23px;
        height: 14px;
        border-radius: 0 0 15px 15px;
      }
    }

    &.position-down {
      top: 0 !important;
      border-radius: 0 0 15px 15px;
      box-shadow: 1px -2px 10px rgba(0, 0, 0, 0.2);

      .placeholder-content {
        .bottom-placeholder {
          background: #fa6000;
        }
      }
    }

    .lz-position-close-btn {
      position: absolute;
      right: 28px;
      width: 150px;
      height: 79px;
      background: #fa6000;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
      border-radius: 0 0 15px 15px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      font-family: 'Roboto-Flex', sans-serif;
      cursor: pointer;
      padding: 0 28px;
    }

    /* 添加延迟隐藏类 */
    &.hide-after-animation {
      animation: hideAfter 0.5s 0.5s forwards;
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes hideAfter {
    to {
      opacity: 0;
      height: 0;
      padding: 0;
      margin: 0;
      overflow: hidden;
    }
  }
}

@media (min-width: 900px) and (max-width: 1280px) {
  .us-header {
    width: 100%;
    max-width: 100%;
  }

  .us-header .us-second-nav,
  .us-header .us-first-nav {
    width: 100%;
    max-width: 100%;
  }

  .us-header .us-second-nav .logo .log-img {
    width: 165px;
    height: 24px;
  }

  .us-header .us-second-nav .second-nav-item {
    padding: 29px 8px;
  }

  .us-header .us-second-nav .second-nav-wrap,
  .us-header .us-first-nav .first-nav-wrap {
    width: 900px;
    max-width: 900px;
  }

  .us-header .us-second-nav .second-nav-mid {
    flex: 1;
    margin-left: 66px;
  }

  .us-header .us-second-nav .second-nav-right .logged-content:hover .logged-in-wrap .dropdown-list-wrapper {
    left: auto;
    right: 0;
    transform: translateX(0);
  }

  .us-header .us-second-nav .second-nav-right .logged-content {
    margin-left: 12px;
  }
}

/* 响应式调整 */
@media (max-width: 899px) {
  .us-header {
    .us-first-nav {

      .first-nav-wrap {
        display: flex;

        .nav-item {
          flex: 1;
          height: 10.667vw;
          font-family: Poppins;
          font-weight: 600;
          font-style: SemiBold;
          font-size: 4vw;
          leading-trim: NONE;
          line-height: 100%;
          letter-spacing: 0%;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          &.active {
            background: #DB4D00;
          }
          .fist-nav-icon {
            width: 12vw;
            height: 4.8vw;
            margin-bottom: 1.333vw;
          }
        }
        .nav-item-link {
          margin-left: 1.067vw;
        }

      }
    }

    .us-second-nav {
      position: relative;
      padding: 0 5.333vw;
      width: 100%;
      height: 14.933vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #FFFFFF99;
      backdrop-filter: blur(16vw);

      .log {
        .log-img {
          width: 40.267vw;
          height: 5.867vw;
        }
      }

      .us-second-nav-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .evaluation-btn {
        padding: 1.067vw 2.667vw;
        background: #FF5A00;
        font-family: Poppins;
        font-weight: 500;
        font-style: Medium;
        font-size: 3.733vw;
        leading-trim: NONE;
        letter-spacing: 0%;
        text-align: center;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 53.333vw;
        margin-right: 6.4vw;
        &:active {
          background: #DB4D00;
        }
      }

      .switch-btn {
        width: 6.4vw;
        height: 6.4vw;
        cursor: pointer;
      }

      .icon-menu-open-btn {
        background: url('assets/images/common/touch-menu.png') no-repeat;
        background-size: 100% 100%;
      }

      .icon-menu-close-btn {
        background: url('assets/images/common/touch-menu-close.png') no-repeat;
        background-size: 100% 100%;
      }

      .logo-href {
        display: block;
        img {
          display: block;
          width: 40.267vw;
          height: 5.867vw;
        }
      }
    }

    .us-header .us-second-nav .second-nav-right .logged-content:hover .logged-in-wrap .dropdown-list-wrapper {
      left: auto;
      right: 0;
      transform: translateX(0);
    }

    .lead-info-box {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 3000;
      display: none;
      background: #fff;
      width: 100%;

      .lead-title {
        position: sticky;
        height: 17.6vw;
        background: #fff;
        text-align: center;
        line-height: 17.6vw;
        color: #45454c;
        font-size: 6.4vw;

        .iconcha {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 7.2vw;
          display: inline-block;
          font-size: 5.867vw;
          color: #9173ff;
        }
      }

      .loading-content {
        width: 100%;
        height: 100vh;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .loader {
          width: 13.333vw;
          height: 13.333vw;
          border: 1.333vw solid #f3f3f3;
          border-top: 1.333vw solid #9173ff;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
      }

      .lead-components {
        width: 100%;
        height: auto;
        min-height: auto;
        max-height: none;
        border-radius: 0;
        box-shadow: none;
      }
    }

    .lead-info-box ::v-deep(.lead-components .title),
    .lead-info-box ::v-deep(.lead-components .bottom-placeholder) {
      display: none;
    }

    .lead-info-box ::v-deep(.lead-components .content .invisible-lable) {
      padding: 0 6.933vw;
    }
  }
}
</style>
